const Tes_Data = [
  {
    id: 1,
    desc: "For customer retention : While every business continually seeks new customers to thrive, keeping current customers happy is a big win as well. Testimonials help to secure customer retention. Well-structured and detailed testimonials will help to boost customer retention.",
    name: "KEVIN MARTHIN",
    profile: "https://tranquil-licorice-79e76f.netlify.app/images/profile/profile1.jpg",
    post: "Developer",
  }
  ,
  {
    id: 2,
    desc: "Build better audience connections : People respond better when a testimonial is from someone that has experienced the same things as them. Thus, hospitality companies can use testimonials to connect with their targeted audience.",
    name: "SUSAN DAY",
    profile: "https://tranquil-licorice-79e76f.netlify.app/images/profile/profile4.jpg",
    post: "CEO",
  },
  {
    id: 3,
    desc: "Sell without selling : While it can be beneficial to persist when trying to sell a  service, it quickly becomes annoying. At some point, all of us have probably encountered a guest that simply refuses to quit. Annoying, people generally dislike being sold to by complete strangers. Because testimonials focus on the benefits to someone just like them, they stand out to prospects as unbiased accounts of how well your services work.",
    name: "JOIN MANSOOR",
    profile: "https://tranquil-licorice-79e76f.netlify.app/images/profile/profile3.jpg",
    post: "Support-Marketing",
  },
  {
    id: 4,
    desc: "To build trust : If you were driving past a new hotel and you saw a poster that said: “we have the best accommodation in the state” would that be enough motivation to convince you to spend some days there? Probably not. However, if you asked around and an acquaintance mentioned that they had stayed there and thoroughly enjoyed the services, you’d most likely rethink and try the place out.",
    name: "JOE GABRIEL",
    profile: "https://tranquil-licorice-79e76f.netlify.app/images/profile/profile2.jpg",
    post: "Designer",
  },
  {
    id: 5,
    desc: " Increase social media engagement : With the continuous proliferation of smartphones and other mobile devices, companies that ignore social media stand the risk of losing out on its immense benefits.",
    name: "MICHAEL DAVID",
    profile: "https://tranquil-licorice-79e76f.netlify.app/images/profile/profile5.jpg",
    post: "Consultant",
  },
  {
    id: 6,
    desc: "Additionally, they’re also telling your prospects what you can now do for them as well. This will save you some of the work and expense of more traditional advertising. Again, social media engagement works like a prompt and a direct conversation between you and your prospects. ",
    name: "MEGAN MILLER",
    profile: "https://tranquil-licorice-79e76f.netlify.app/images/profile/profile6.jpg",
    post: "Founder",
  }
]

export default Tes_Data;